module.exports = __webpack_public_path__ + "media/application/images/svgs/cloud-rain-68c3470557cae9310bb2802bfb3ced50.svg";